import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+1.200',
    label: 'Personas ya con el sistema'
  }, {
    value: '+300',
    label: 'Recetas paso a paso'
  }, {
    value: '21',
    label: 'Días para notar el cambio'
  }, {
    value: '30',
    label: 'Días de garantía total'
  }];
  return <div className="bg-brand-primary w-full" data-id="element-199" data-mp="1jd3ozjdwwj2q">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-3 px-4 py-8 md:py-10" data-id="element-200" data-mp="1jeesdi3g3otb">
        {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-201" data-mp="19mr5zvlqwxyp" data-mpi={i}>
            <div className="font-display text-2xl md:text-4xl font-bold text-brand-secondary mb-1" data-id="element-202" data-mp="19ky0ijmvcjsa">
              {stat.value}
            </div>
            <div className="text-white/85 text-[11px] md:text-sm font-body leading-tight" data-id="element-203" data-mp="10m2r6yoj2tkr">
              {stat.label}
            </div>
          </div>)}
      </div>
    </div>;
}